import React from 'react'
import "./StandardPopup.css"

import { Modal } from "@mui/material";

import PopUpResponseButton from '../../Buttons/PopUpResponseButton/PopUpResponseButton';

/*
 yesFcn executes on clicking the yes button. it also automatically closes the popup.
 noFcn executes on clicking the no button. it also automatically closes the popup.
 message and message2 are rendered on different lines. Ghetto af
**/

export default function StandardPopup({isOpen,yesFcn,noFcn,message,message2,icon}) {


    const [open, setOpen] = React.useState(isOpen); // handles if popup is open. This has to be done outside of the component via state

    //this is so if it changes outside of this componenet it still updated this component. React shit
    React.useEffect(() => {
        setOpen(isOpen); 
    },[isOpen])


    return <Modal open={open}>
    <div className="popupMembersContainer" data-testid="standardPopup">
      <img src={icon} alt="Sigur?" />
      <div className="popupMembersText">{message}</div>
      <div className="popupMembersText">{message2}</div>
      <div className="popupMembersButtonsContainer">
        <PopUpResponseButton
          type={"yes"}
          text={"Da"}
          onClick={() => {
            if(yesFcn) {
                yesFcn()
            }
            setOpen(false);
          }}
        />
        <PopUpResponseButton
          type={"cancel"}
          text={"Nu"}
          onClick={() => {
            // setIsChanging(false);
            // setPopupOpen(false);
            if(noFcn) {
                noFcn()
            }
            setOpen(false);
        }}
        />
      </div>
    </div>
  </Modal>
}